import { render, staticRenderFns } from "./ComplaintGroupForm.vue?vue&type=template&id=936db80a&"
import script from "./ComplaintGroupForm.vue?vue&type=script&lang=js&"
export * from "./ComplaintGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports